<template>
  <div class="textarea" :class="{ 'textarea--inverse': inverse }">
    <label for="">{{ label }}</label>
    <textarea 
      v-bind="$attrs"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)">  
    </textarea> 
  </div>
</template>

<style scoped lang="scss">
  .textarea {
    width: 100%;
    margin-bottom: 30px;

    label {
      display: block;
      margin-bottom: 5px;

      font-size: var(--p);
      font-weight: var(--weight-bold);
      color: rgb(var(--blue-0));
    }

    textarea {
      width: 100%;
      padding: 0.8em 1em;
      border: 2px solid rgb(var(--gray-0));
      border-radius: 4px;
      background-color: transparent;

      font-size: var(--p);

      &::placeholder {
        color: rgb(var(--gray-0));
      }
    }

    &--inverse {
      label {
        color: rgb(var(--white));
      }

      textarea {
        border-color: rgb(var(--white));

        &::placeholder {
          color: rgba(var(--white), 0.5);
        }
      }
    }
  }
</style>

<script>
  export default {
    name: 'InputTextarea',

    inheritAttrs: false,

    props: {
      label: {
        type: String,
        default: ''
      },

      value: {
        type: String,
        required: true
      },

      inverse: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      
    }),

    computed: {

    },

    methods: {

    },

    created () {

    }
  };
</script>